import { StoreProductField } from 'app/models/types/store/product';
import {
  cmsApiOnProductChangeSelector,
  currentProductTypesExtendedSelector,
  currentProductTypesSelector,
  selectedProductsSelector,
} from 'app/store/selectors';
import { ThunkType } from 'app/hooks/appHooks';
import { ProductsId } from '@webc/meeseeks-ui-sdk';
import { setProductQuantity, setRelationProducts } from 'app/store/reducers/product';

export type UpdateProductQuantityType = {
  productType: ProductsId;
  quantity: number;
};
export const updateProductQuantity =
  ({ productType, quantity }: UpdateProductQuantityType): ThunkType<void> =>
  (dispatch, getState) => {
    dispatch(setProductQuantity({ productType, quantity }));
    const state = getState();
    const products = selectedProductsSelector(state) as StoreProductField['types'];
    const onProductChanged = cmsApiOnProductChangeSelector(state);
    const currentProductTypes = currentProductTypesSelector(state);
    const currentProductTypesExtended = currentProductTypesExtendedSelector(state);
    onProductChanged(products);
    dispatch(
      setRelationProducts({
        relationProducts: { ...currentProductTypes, ...currentProductTypesExtended },
      }),
    );
  };
